__webpack_require__.p = "https://us-west-2.beta.categorymanagement.wwgs.amazon.dev/";